module.exports = __webpack_public_path__ + "static/media/app-intro-2.ac2b9dd2.jpg";